<template>
  <BaseModal modal-content-class="resub">
    <div class="content">
      <h1>{{ $_translations.value.modal_resubscribe_via_sms_title }}</h1>

      <BaseImage
        src="/static/images/modals/resubscribe/resubscribe_icon.svg"
        alt="Resubscribe"
        image-class="top_img"
      />

      <h2>{{ $_translations.value.modal_resubscribe_via_sms_subtitle }}</h2>

      <p>{{ $_translations.value.modal_resubscribe_via_sms_description }}</p>

      <p>{{ $_translations.value.modal_resubscribe_via_sms_instructions_pt1 }}
        <span class="white_bold">
          <span class="yellow_bold">
            {{ $_translateByOperator('modal_resubscribe_via_sms_instructions_pt2') }}
          </span>
        </span>
        {{ $_translations.value.modal_resubscribe_via_sms_instructions_pt3 }}
        <span class="yellow_bold">
          {{ $_translateByOperator('modal_resubscribe_via_sms_instructions_pt4') }}
        </span>
        .
      </p>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
</script>
